import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./statusBadge.html";
import { Theme as AxBadgeTheme, Variant as AxBadgeVariant } from '@oneappexchange/appx-design-system/modules/ax/badge/badge.constants';
import { WireI18n } from '~/modules/stores/i18nStore';
export let StatusBadgeVariant = /*#__PURE__*/function (StatusBadgeVariant) {
  StatusBadgeVariant["Beta"] = "beta";
  StatusBadgeVariant["New"] = "new";
  StatusBadgeVariant["Updated"] = "updated";
  return StatusBadgeVariant;
}({});
const STATUS_BADGE_BASE_CLASS = 'status-badge';
class StatusBadge extends LightningElement {
  constructor(...args) {
    super(...args);
    this.variant = StatusBadgeVariant.Beta;
    this.size = 'default';
    this.labels = void 0;
  }
  get badgeLabel() {
    return this.labels?.[this.variant] ?? this.labels?.[StatusBadgeVariant.Beta] ?? '';
  }
  get badgeClassName() {
    const variantClass = this.variant === StatusBadgeVariant.Updated ? `${STATUS_BADGE_BASE_CLASS} status-badge--updated` : STATUS_BADGE_BASE_CLASS;
    return this.size === 'small' ? `${variantClass} status-badge--small` : variantClass;
  }
  get badgeDisplayVariant() {
    return this.variant === StatusBadgeVariant.Updated ? AxBadgeVariant.Outline : AxBadgeVariant.Default;
  }
  get badgeTheme() {
    return this.variant === StatusBadgeVariant.Updated ? AxBadgeTheme.Blue : AxBadgeTheme.Gold;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(StatusBadge, {
  publicProps: {
    variant: {
      config: 0
    },
    size: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: i18n => i18n.statusBadge
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(StatusBadge, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;